import React from "react";

import DashboardLayout from "@/components/layout/DashboardLayout";
import { Button } from "@/components/ui/button";
import Typography from "@/components/ui/typography";
import MentorsTable from "@/features/mentors/components/MentorsTable";
import NewMentorDrawer from "@/features/mentors/components/NewMentorDrawer";

const Mentors = () => {
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [selectedMentorId, setSelectedMentorId] = React.useState<string | null>(
    null,
  );

  const onSetViewEditMentor = (id: string) => {
    setSelectedMentorId(id);
    setOpenDrawer(true);
  };

  const onClearMentorSelection = () => {
    setSelectedMentorId(null);
    setOpenDrawer(false);
  };

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <Typography size="h1">Mentors</Typography>
          <Button onClick={() => setOpenDrawer(true)}>New Mentor</Button>
        </div>

        <MentorsTable setMentorId={onSetViewEditMentor} />

        <NewMentorDrawer
          open={openDrawer}
          setOpen={setOpenDrawer}
          selectedMentorId={selectedMentorId}
          onClearMentorSelection={onClearMentorSelection}
        />
      </div>
    </DashboardLayout>
  );
};

export default Mentors;
